export default __webpack_public_path__ + "media/images/avatars/avatar15-0e1e6f9c675730b06e12446dbe60ff5f.png";